import React, { useState, useEffect } from 'react';
import { getURLwithoutPro, isEven, getQueryParamsFromString, getQueryParamsFromEncryptedSearch, convertToINRabbreviations, addAgentCode } from '__utils/common-utils';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import { useDispatch, useSelector } from 'react-redux';
import { CommonStyledComponentProps } from '__utils/type';
import "react-datepicker/dist/react-datepicker.css";
import { getEventName, Mixpanel } from '__utils/mixpanel';
import { getAgentCode } from '__utils/storage';
import { Row, Col } from 'antd';
import { LayoutContext } from 'components/app-routes';
import CalculatorForm from '../calculator-form';
import CalculationResult from '../calulation-result';
import { COLOR } from 'constants/colors';
import { setCustomerFromSharedLinkDetails, setShareCalculatorConfig, shareCalculatorViaWhatsapp } from '../investment-calculator.actions';
import { SipLumpsumTitle } from 'views/calculators/calculator-helper';
import { propsToJS } from '__utils/immutable-to-js';
import InvestmentCalculatorSelector from '../investment-calculator.selector';
import { CalculatorAdvisor } from 'components/common-components';
import TopRatedFundsSlider from 'views/calculators/top-funds-slider';
import { isBtoCFlow } from '__utils/common-utils';
import { useDeepCompare } from 'hooks/use-deep-memo';


export const GoalCardWrapper = styled.div<CommonStyledComponentProps | any>`
    margin: 0 auto;
    height: auto;
    overflow: auto;
    padding: ${(props: any) => props.isMobile ? '16px' : '0'};
    border-radius: 12px;
    margin-bottom: 30px;
    overflow-x: hidden;
    background-color: ${(props: any) => props.isMobile ? `${COLOR.WHITE}` : `none`};
    box-shadow: ${(props: any) => props.isMobile ? `0px 2px 8px ${COLOR.LIGHTGREY}` : `none`};
    .yearText{
        color: #121617;
        line-height: 1.8;
        font-weight: 500 !important;
        font-size: ${(props: any) => props.isMobile ? '12px' : '14px'};
    }
    #sip-result{
        font-weight: 600;
        max-width: 250px;
    }

`;
export const CalculatorDiv = styled.div<CommonStyledComponentProps | any>`
    padding: ${(props: any) => props.isMobile ? `0` : `30px`};
    box-shadow: ${(props: any) => props.isMobile ? 'none' : `4px 4px 20px rgba(106, 106, 106, 0.1);`};
    background: ${(props: any) => props.isMobile ? `${COLOR.WHITE}` : `linear-gradient(99.57deg, rgba(223, 226, 231, 0.6) 0%, #FFFFFF 54.41%, rgba(205, 229, 218, 0.6) 97.25%)`};
    border-radius: 12px;
`;

const SipCalculator: React.FC = () => {

    const dispatch = useDispatch();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const [graphData, setGraphData] = useState<any>([]);
    const [totalInvested, setTotalInvested] = useState<any>();
    const [totalGains, setTotalGains] = useState<any>();
    const [investmentValues, setInvestmentValues] = useState<{ rateOfReturn: number, timePeriod: number, investmentAmt: number }>({ rateOfReturn: 8, timePeriod: 10, investmentAmt: 5000 });
    const [finalTimePeriod, setFinalTimePeriod] = useState<any>();
    const { shareCalculatorConfig, shareWithCustomerDetails, shareCalcBtnClicked, sipLumpsumCalculatorFormValues } = propsToJS(useSelector(InvestmentCalculatorSelector));
    const { layoutProps, SetLayoutProps } = React.useContext(LayoutContext);


    const encryptedLink = (clientName?: string) => window.btoa(`sharedByAgent=${getAgentCode()}&amount=${shareCalculatorConfig?.shareData?.goalAmount}&tp=${shareCalculatorConfig?.shareData?.timePeriod}&RoR=${shareCalculatorConfig?.shareData?.rateOfReturn}` + `${clientName ? `&clientName=${clientName}` : ''}`);
    const getShareCalcUrl = (clientName?: string) => getURLwithoutPro(`${window.location.pathname}?${encryptedLink(clientName)}`);
    const getShareMsg = (clientName?: string) => `${clientName ? `Hello ${clientName}` : 'Hello'},\n${clientName ? "Here's your personalised SIP calculator result." : "Here’s a SIP investment plan for you."}\nPlease click on the link below to use Turtlemint Money SIP calculator`;

    //get query params from shared url
    useEffect(() => {

        if (getQueryParamsFromEncryptedSearch()) {
            const sharingLinkDets = (getQueryParamsFromString(`?${getQueryParamsFromEncryptedSearch()}` || ''));
            const { amount, tp, RoR } = sharingLinkDets;
            setInvestmentValues({ rateOfReturn: +RoR, timePeriod: +tp, investmentAmt: amount });
            dispatch(setCustomerFromSharedLinkDetails(sharingLinkDets));
        }
        Mixpanel.track(getEventName("sipCalculator", "loaded", "calculator"));
    }, [])

    useEffect(() => {
        SetLayoutProps({
            showGlobalFooter: true,
            breadcrumbList: [{ text: 'Home', url:  addAgentCode('v1/home'), isExternal: true }, { text: 'SIP Calculator', url: '' }],
        })
        if (Object.keys(sipLumpsumCalculatorFormValues).length) {
            calculateGains(sipLumpsumCalculatorFormValues)
        }
        setFinalTimePeriod(sipLumpsumCalculatorFormValues?.timePeriod);
    }, [useDeepCompare(sipLumpsumCalculatorFormValues)])


    //@purpose- calculate gains,futurvalue,data for graph
    const calculateGains = (formValues: any) => {
        const RoR = formValues?.rateOfReturn;
        const TimePeriod = formValues?.timePeriod;
        const monthlySIP = formValues?.investmentAmt;

        const I = RoR / 1200;
        const gainsArr: any[] = [];
        const investedAmtArr: any[] = [];
        const yearArr: any[] = [];

        //calculate year by year
        for (let index = 1; index <= TimePeriod; index++) {
            const N = index * 12;
            const targetAmount = (monthlySIP * ((Math.pow((1 + I), N) - 1) / I) * (I + 1));
            const investedAmount = monthlySIP * N;
            const gains = targetAmount - investedAmount;

            const pushIntoDataset = () => {

                gainsArr.push({
                    value: gains,
                });
                investedAmtArr.push(
                    {
                        value: investedAmount,
                    }
                );
                yearArr.push(`${index}y`);
            }

            if (TimePeriod > 10 && TimePeriod <= 20) {
                if (isEven(TimePeriod)) {
                    if (isEven(index)) {
                        if (index === TimePeriod) {
                            pushIntoDataset()
                        }
                        else continue;
                    }
                    else pushIntoDataset()
                }
                else {
                    if (isEven(index)) continue;
                    else pushIntoDataset()
                }
            }
            else if (TimePeriod > 20) {
                if (index % 3 === 1 || index === 1 || index === TimePeriod) {
                    pushIntoDataset();
                }
                else continue;
            }
            else pushIntoDataset();

            setGraphData({ xAxisData: yearArr, gains: gainsArr, invested: investedAmtArr });

            if (index === TimePeriod) {
                setTotalInvested(investedAmount);
                setTotalGains(gains);
            }
        }

        dispatch(setShareCalculatorConfig(
            {
                shareData: {
                    calculatorType: 'Start monthly SIP with ',
                    showCalcDescription: '',
                    investmentValue: convertToINRabbreviations(monthlySIP),
                    goalAmount: monthlySIP,
                    rateOfReturn: RoR,
                    timePeriod: TimePeriod,
                }
            }
        ))

    }


    //@purpose- get customer details & save in shareconfig
    useEffect(() => {
        shareCalcBtnClicked && dispatch(setShareCalculatorConfig(
            {
                ...shareCalculatorConfig,
                shareData: {
                    ...shareCalculatorConfig.shareData,
                    clientName: shareWithCustomerDetails?.clientName,
                    calculatorTitle: shareWithCustomerDetails?.clientName ? "Sharing personalised investment growth plan (SIP) for you" : "Here's an investment plan for you",
                },
                shareMessage: getShareMsg(shareWithCustomerDetails?.clientName),
                originalUrl: getShareCalcUrl(shareWithCustomerDetails?.clientName)
            }
        ));
        shareCalcBtnClicked && dispatch(shareCalculatorViaWhatsapp(true));
    }, [shareCalcBtnClicked])

    return (
        <>
            <GoalCardWrapper isMobile={isMobile}>
                <Row style={{ justifyContent: 'space-between' }}>
                    <Col xs={24} md={18}>
                        <SipLumpsumTitle isMobile={isMobile}>
                            <p className='greenBoldTxt'>Personalised Investment Growth</p>
                            <h3>Systematic Investment Plan Calculator</h3>
                            <span>{isBtoCFlow() ? 'Visualise your financial growth' : 'Visualise your client’s financial growth'}</span>
                        </SipLumpsumTitle>
                    </Col>
                    <Col xs={0} md={6}>
                        <div>
                            <CalculatorAdvisor />
                        </div>

                    </Col>
                </Row>
                <br />
                <CalculatorDiv isMobile={isMobile}>
                    <Row style={{ flexDirection: isMobile ? 'column' : 'row-reverse' }} justify='space-between' align={isMobile ? 'stretch' : 'middle'}>
                        <Col xs={24} md={13} >
                            <CalculationResult
                                resultAmount={totalInvested + totalGains}
                                totalInvestment={totalInvested}
                                gains={totalGains}
                                graphData={graphData}
                                resultTitle={<div>
                                    <p id='sip-result'>Future Value <span className='yearText'>(after {finalTimePeriod}{investmentValues?.timePeriod === 1 ? ' year' : ' years'})</span>
                                    </p>
                                </div>}

                            />
                        </Col>
                        <Col xs={24} md={10} className={isMobile ? 'mt24' : ''}>
                            <CalculatorForm
                                defaultAmountTabs={isMobile ? [5000, 3000, 2000] : [10000, 5000, 3000, 2000]}
                                defaultValues={investmentValues}
                                inputLabel='Monthly Investment'
                                rules={{
                                    min: {
                                        value: 100, message: 'Minimum value allowed is 100'
                                    },
                                    max: {
                                        value: 100000, message: 'Maximum value allowed is 1,00,000'
                                    },

                                }}
                            />
                        </Col>
                    </Row>
                </CalculatorDiv>
                <TopRatedFundsSlider />
            </GoalCardWrapper>
        </>
    )
}

export default SipCalculator